// SOURCE: https://github.com/yixizhang/seed-shuffle

/**
 * This is an util to generate a shuffled array, with deterministic randomness provided by the seed.
 *
 * @param array - The array to be shuffled
 * @param seed - The seed to generate the randomness
 * @returns The shuffled array
 */
export var shuffleWithSeed = function shuffleWithSeed(array) {
  var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1332712639;
  var currentIndex = array.length;
  var temporaryValue;
  var randomIndex;
  seed = seed || 1;

  var random = function random() {
    var x = Math.sin(seed++) * 10000;
    return x - Math.floor(x);
  }; // While there remain elements to shuffle...


  while (currentIndex !== 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(random() * currentIndex);
    currentIndex -= 1; // And swap it with the current element.

    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
};

var deterministicShuffle = function deterministicShuffle(array, someRandom) {
  return shuffleWithSeed(array, someRandom);
};

export default deterministicShuffle;